<template>
    <section class="products-promises content-section">
        <b-container>
            <h2 style="margin-bottom: 50px">OUR PROMISES</h2>
            <b-row>
                <b-col 
                    class="d-flex align-items-center justify-content-md-center mb-3"
                    v-for="(info, i) in infos" :key="i"
                    md="4"
                >
                    <div class="img-wrap">
                        <b-img :src="info.icon" fluid></b-img>
                    </div>
                    <div class="desc-wrap">
                        <h3>{{info.title}}</h3>
                        <p>{{info.desc}}</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            infos: [
                {
                    icon: require('@/assets/images/products_page/promises_icon_01.png'),
                    title: 'BEST QUALITY',
                    desc: 'WE CAN PROMISE',
                },
                {
                    icon: require('@/assets/images/products_page/promises_icon_02.png'),
                    title: '100%',
                    desc: 'ON TIME DELIVERY',
                },
                {
                    icon: require('@/assets/images/products_page/promises_icon_03.png'),
                    title: 'SUPERIOR PRODUCTS',
                    desc: 'WE CAN MAKE',
                }
            ]
        }
    },
}
</script>

<style lang="scss">
    .products-promises{
        color: #fff;
        // background-attachment: scroll;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url("~@/assets/images/products_page/promises_bg.jpg");

        h2{
            font-weight: bold;
            color: rgba(255,255,255,1);
            text-align: center;
            text-shadow: 3px 3px 5px #060001;
            letter-spacing: 5px;
        }

        .img-wrap{
            margin-right: 30px;

            img{
                width: 60px;
            }
        }

        .desc-wrap{
            h3,p {
                margin-bottom: 0;
            }
            
            h3 {
                margin-bottom: 5px
            }
            p {
                color: #ccc
            }
        }
    }
</style>